import React, { useState, forwardRef, Fragment } from "react";
import { Button } from '../../components/Wrappers'
import { InputAdornment,
         FormControl, InputLabel, Select, Input, Chip, MenuItem,
         NativeSelect, FormControlLabel, Checkbox} from "@material-ui/core";
// components
import SelectCustomer from '../../components/Customer/SelectCustomer';

// Icons
import {
    HomeWork as HomeWorkIcon
} from '@material-ui/icons'

import { useUserState } from "../../context/UserContext";
import useStyles from './styles';
import config from '../../config';
import classnames from "classnames";
import "./Overdue.css";


const Overdue = forwardRef((props, ref) => {
    var classes = useStyles();
    var { regions } = useUserState();
    const [selectedRegions, setSelectedRegions] = useState([]);
    const [regionSelectionOpen, setRegionSelectionOpen] = useState(false);
    const [selectedIsAll, setSelectedIsAll] = useState('YES');
    const [selectedIsAllCustomers, setSelectedIsAllCustomers] = useState('YES');
    const [selectedOverdue, setSelectedOverdue] = useState('1 month');
    const [onlyAfterLastSiteVisit, setOnlyAfterLastSiteVisit] = useState(true);
    const [selectedCustomer, setSelectedCustomer] = useState(undefined);
    const [selectedCustomerId, setSelectedCustomerId] = useState(-1);

    const ITEM_HEIGHT = 48;
    const ITEM_PADDING_TOP = 8;
    const MenuProps = {
      PaperProps: {
        style: {
          maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
          width: 250,
        },
      },
    };

    const handleChange = (event) => {
        setSelectedRegions(event.target.value);
    };

    const handleDelete = (id) => {
      const updatedRegions = selectedRegions.filter(item => item.id !== parseInt(id));
      setSelectedRegions(updatedRegions);
    };

    const onMouseDown = e => {
      e.stopPropagation();
    };


    function handleChangeIsAll(e) {
      setSelectedIsAll(e.target.value);
      if (e.target.value === 'YES') {
        setSelectedRegions([]);
      }
    }

    function handleChangeIsAllCustomers(e) {
      setSelectedIsAllCustomers(e.target.value);
      if (e.target.value === 'YES') {
        setSelectedCustomer(undefined);
        setSelectedCustomerId(-1);
      }
    }

    function generateOverdueReport() {
      let regionIds = selectedRegions === undefined || selectedRegions === null || selectedRegions.length > 0 ?
              selectedRegions.map(service => service.id).toString() : '';
      console.log(`${config.clientApi}/reports/customers_overdue?&active=true&customer_id=${selectedCustomerId}&overdue=${encodeURIComponent(selectedOverdue)}&is_after_last_site_visit=${onlyAfterLastSiteVisit}${regionIds === undefined || regionIds === null || regionIds === '' ? '' : `&regionIds=${regionIds}`}`);
      window.open(
          `${config.clientApi}/reports/customers_overdue?&active=true&customer_id=${selectedCustomerId}&overdue=${encodeURIComponent(selectedOverdue)}&is_after_last_site_visit=${onlyAfterLastSiteVisit}${regionIds === undefined || regionIds === null || regionIds === '' ? '' : `&regionIds=${regionIds}`}`,
          '_blank'
      );
    }

    function handleSelectedOverdue(e) {
        setSelectedOverdue(e.target.value);
    }

    function handleOnlyAfterLastSiteVisit(e) {
        setOnlyAfterLastSiteVisit(e.target.checked);
    }

    function onSelectCustomer(customer) {
      setSelectedCustomer(customer);
      setSelectedCustomerId(customer !== null && customer !== undefined ? customer.id : -1);
    }

    function onSelectCustomerFormUpdated(isValid) {

    }


    return (
      <>

          <FormControl variant="outlined" style={{ marginBottom: 20 }}
            className={classnames({
                'select-control': true
              })}>
            <InputLabel>Expired in the last:</InputLabel>
            <div className={classnames({
                          'select-control-input': true,
                          'overdue-select-control-input': true
                        })}>
              <NativeSelect
                value={selectedOverdue}
                onChange={handleSelectedOverdue}
              >
                 <option value="1 month">1 month</option>
                 <option value="2 month">2 months</option>
                 <option value="3 month">3 months</option>
                 <option value="6 month">6 months</option>
                 <option value="9 month">9 months</option>
                 <option value="1 year">1 year</option>
                 <option value="2 year">2 year</option>
                 <option value="3 year">3 year</option>
                 <option value="4 year">4 year</option>
                 <option value="5 year">5 year</option>
              </NativeSelect>
            </div>
          </FormControl>

                <FormControl variant="outlined"
                             style={{ marginBottom: 20 }}
                             className={classnames({
                      'isAllRegionsSelect':  true,
                      'overdue-select-control': true
                    })}>
                  <InputLabel id="is_all">All Regions?</InputLabel>
                  <div className={classnames({
                                'select-control-input': true
                              })}>
                    <NativeSelect
                      value={selectedIsAll}
                      onChange={handleChangeIsAll}
                    >
                       <option value="YES">YES</option>
                       <option value="NO">NO</option>
                    </NativeSelect>
                  </div>
                </FormControl>

                {selectedIsAll === 'NO' && <FormControl variant="outlined"
                             className={classnames(classes.regions, {
                              'overdue-control': true
                            })}>
                  <InputLabel id="regions-label">Regions</InputLabel>
                  <div className={classnames(classes.regionsInput, {
                                'overdue-control-input': true
                              })}>
                  <InputAdornment position="start">
                    <HomeWorkIcon />
                  </InputAdornment>
                  <Select
                    labelId="regions-label"
                    id="regions"
                    multiple
                    className={classes.regionsSelect}
                    value={selectedRegions}
                    onChange={handleChange}
                    open={regionSelectionOpen}
                    onClose={() => {setRegionSelectionOpen(false);}}
                    onOpen={() => {setRegionSelectionOpen(true);}}
                    input={<Input id="region-chip" />}
                    renderValue={(selected) => (
                      <div className={classes.chips}>
                        {selected.map((value) => {
                          return (
                            <Fragment key={value.id || value}>
                                <Chip label={value.name || regions.filter(item => item.id === value)[0].name}
                                      className={classes.chip}
                                      onDelete={() => handleDelete(`${value.id}`)}
                                      variant="outlined"
                                      onMouseDown={onMouseDown}/>
                              </Fragment>
                        );
                      })}
                      </div>
                    )}
                    MenuProps={MenuProps}
                    size="small"
                  >
                    {regions !== undefined && regions !== null &&
                      regions.length > 0 &&
                      regions.map((region, index) => (
                           <MenuItem key={region.id} value={region}
                              disabled={selectedRegions.filter(item => item !== undefined && item !== null && (item.id === region.id || item === region.id)).length === 1}
                              onClick={() => {setRegionSelectionOpen(false);}}>
                              <span className="dropdown-avatar">{region.name}</span>
                           </MenuItem>
                    ))}
                  </Select>
                  </div>
                </FormControl>}

                <FormControl variant="outlined"
                             style={{ marginBottom: 20 }}
                             className={classnames({
                      'isAllCustomersSelect':  true,
                      'overdue-select-control': true
                    })}>
                  <InputLabel id="is_all_customer">All Customers?</InputLabel>
                  <div className={classnames({
                                'select-control-input': true
                              })}>
                    <NativeSelect
                      value={selectedIsAllCustomers}
                      onChange={handleChangeIsAllCustomers}
                    >
                       <option value="YES">YES</option>
                       <option value="NO">NO</option>
                    </NativeSelect>
                  </div>
                </FormControl>

                {selectedIsAllCustomers === 'NO' && <FormControl variant="outlined"
                             className={classnames(classes.customers, {
                              'overdue-control': true,
                              'customers-control': true
                            })}>
                      <SelectCustomer labelName="Type to Search and Select Customer"
                                        selectedCustomer={selectedCustomer}
                                        onSelect={onSelectCustomer}
                                        onFormUpdated={onSelectCustomerFormUpdated}/>
                </FormControl>}

                <FormControlLabel style={{width: '100%'}}
                  control={
                    <Checkbox
                      checked={onlyAfterLastSiteVisit}
                      onChange={handleOnlyAfterLastSiteVisit}
                      color="primary"
                    />
                  }
                  label="Only After Last Site Visit"
                />

                <div className={classes.layoutButtonsRow}>
                    <Button onClick={generateOverdueReport} >
                      <span>create</span>
                    </Button>
                </div>

      </>
    );
});

export default Overdue;
